import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { UserRole } from '@tipstrack/shared';
import { useAuth } from '../auth/AuthContext.js';

function CenteredSpinner() {
  return (
    <div className="route-center">
      <div className="spinner" aria-label="Loading" />
    </div>
  );
}

/** Requires an authenticated session; otherwise sends the user to /login. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <CenteredSpinner />;
  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }
  return <>{children}</>;
}

/** Requires one of the given roles on top of authentication. */
export function RoleRoute({ roles, children }: { roles: UserRole[]; children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return <CenteredSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) {
    return (
      <div className="route-center">
        <div className="empty-state">
          <h2>Access denied</h2>
          <p>Your role ({user.role}) does not have access to this page.</p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
